import { useState } from "react"

import { TClockType } from "src/data/user/user"
import {
  MDateTimePicker,
  TDateTimePickerProps,
} from "src/ui/MDateTimePicker/MDateTimePicker"
import { formatDate } from "src/utils/l10n"

import {
  ISettingContainerBaseProps,
  SettingContainer,
  TSettingContainerOnSaveReturnType,
} from "./SettingContainer"

export function SettingDateTime({
  title,
  description,
  value,
  onSave,
  dateTimePickerProps,
  clockType,
  disabled,
}: ISettingContainerBaseProps & {
  dateTimePickerProps?: Omit<TDateTimePickerProps, "onChange" | "initialDate">
  onSave: (newVal: Date | null) => TSettingContainerOnSaveReturnType
  value: Date | null
  clockType?: TClockType
}) {
  const [saveValue, setSaveValue] = useState(value)

  return (
    <SettingContainer
      title={title}
      description={description}
      onSave={async () => {
        return await onSave(saveValue)
      }}
      displayValue={
        value ? formatDate({ date: value.toISOString(), clockType }) : ""
      }
      disabled={disabled}
      InputComponent={({ saving }) => (
        <MDateTimePicker
          initialDate={value}
          onChange={(date) => {
            setSaveValue(date)
          }}
          disabled={saving || disabled}
          {...dateTimePickerProps}
        />
      )}
    />
  )
}
